export const serviceOrderLabelEndpoints = {
  query: '/serviceOrderLabel/query',
}
